module.exports = __webpack_public_path__ + "static/img/cont55 (3).3da52f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont55 (3).jpg
// module id = q+2e
// module chunks = 0